"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var uuid_1 = require("uuid");

var INTEREST_TYPES = __importStar(require("../constants/interests"));

var createParty_1 = __importDefault(require("../parties/createParty"));

var CASE_CONTEXT_TYPES = __importStar(require("./types"));

function initialState() {
  var _incomeScheduleI, _incomeSOFA, _incomeMeansTest;

  var base = {
    class: "legal_context",
    type: CASE_CONTEXT_TYPES.BANKRUPTCY,
    // subType: 'chapter7', NOTE: Just an idea.
    // General
    caseNumber: null,
    chapter7: true,
    district: null,
    amendedFiling: false,
    date: null,
    proSe: {
      bankruptcyConseqeuences: true,
      accurateForms: true
    },
    preparer: {
      paid: false,
      name: null
    },
    lsp: {},
    attorney: null,
    // Debtors (party)
    debtor1: null,
    debtor2: null,
    married: false,
    housing: {
      renter: null,
      evictionJudgment: null,
      landlord: null
    },
    // General - Parts 1-7
    bankruptcysPrevious: [],
    bankruptcysPending: [],
    hazardousProperty: null,
    debtsPrimarilyConsumer: true,
    debtsPrimarilyOther: null,
    filingFee: {
      method: null,
      additionalDescription: null,
      installments: [] // date, value, onFiling (first installment)

    },
    filingReason: null,
    // Schedule A/B/C
    assets: [],
    // exemptions: [], // NOTE: Gets generated on output. Exemptions nested in assets
    exemptionStateClaimed: null,
    exemptionHomesteadOf160k: false,
    exemptionHomesteadWithin1215: false,
    fundsForCreditors: false,
    // Schedule D/E/F
    claims: [],
    // Schedule G
    contracts: [],
    // Schedule H
    communityProperty: {
      state: null,
      party: null // party (if not null, then it's with a spouse)
      // withSpouse: false,

    },
    codebtors: [],
    // Schedule I
    incomes: [],
    // Schedule J (and a whole bunch of stuff)
    jointFiling: false,
    separateHouseholds: null,
    household: {
      dependents: [],
      expenses: {},
      expensesIncludeOthers: false,
      expensesIncludeOthersDescription: "",
      familySize: 1,
      expectIncomeChange: "",
      expectIncomeChange6Month: "",
      expectExpensesChange: "",
      expectExpensesChange6Month: "",
      expectPayment180Days: "",
      otherContributions: 0
    },
    // SOFA
    transfers: [],
    legalActions: [],
    assigneePossession: false,
    sofa: {},
    environmentalViolationNotice: {},
    environmentalHazardousReleaseNotice: {},
    environmentalLawProceeding: {},
    businesses: [],
    financialStatementRecipients: [],
    // HACK: My income setup shits the bed because I can't derive enough info from the DA interview income summaries.
    // OPTIMIZE: IMO, the other way is the way to go, but doing straight field for field editing now
    // OPTIMIZE: Replace incomeScheduleI by deriving from incomes
    incomeScheduleI: (_incomeScheduleI = {}, _defineProperty(_incomeScheduleI, INTEREST_TYPES.DEBTOR_1, {
      valueIncome: 0,
      valueOvertime: 0,
      valueGrossIncome: 0,
      deductions: {
        // 5
        valueTaxDeductions: 0,
        mandatoryObligations: 0,
        voluntaryObligations: 0,
        loanObligations: 0,
        insurance: 0,
        domesticObligations: 0,
        unionObligations: 0,
        otherDeduction: 0,
        otherDeductionNames: "" // 5h

      },
      valueDeductions: 0,
      valueTakeHomePay: 0,
      nonEmploymentIncome: {
        // 8
        businessProfessionalFarm: 0,
        interestsDividendsRoyalties: 0,
        familySupport: 0,
        unemployment: 0,
        socialSecurity: 0,
        otherGovAssistance: 0,
        otherGovAssistanceNames: "",
        pensionRetirement: 0,
        other: 0,
        otherIncomeNames: ""
      },
      allNonEmploymentIncome: 0,
      monthlyIncome: 0
    }), _defineProperty(_incomeScheduleI, INTEREST_TYPES.DEBTOR_2, null), _defineProperty(_incomeScheduleI, "otherContributions", 0), _defineProperty(_incomeScheduleI, "otherContributionsDescription", ""), _incomeScheduleI),
    // HACK: Part of the hold-over solution
    // OPTIMIZE: Replace incomeSOFA by deriving from incomes
    incomeSOFA: (_incomeSOFA = {}, _defineProperty(_incomeSOFA, INTEREST_TYPES.DEBTOR_1, {// 2018: {
      //   wages: false,
      //   business: false,
      //   income: 0,
      //   otherIncomes: [], // { name: '', value: 0 }
      // }
    }), _defineProperty(_incomeSOFA, INTEREST_TYPES.DEBTOR_2, null), _incomeSOFA),
    // HACK: Part of the hold-over solution
    // OPTIMIZE: Replace incomeMeansTest by deriving from incomes
    incomeMeansTest: (_incomeMeansTest = {}, _defineProperty(_incomeMeansTest, INTEREST_TYPES.DEBTOR_1, {
      valueGrossIncome: 0,
      valueAlimonyMaintenance: 0,
      valueContributionsSupport: 0,
      valueBusinessGross: 0,
      valueBusinessExpenses: 0,
      valueBusinessNetIncome: 0,
      valuePropertyGross: 0,
      valuePropertyExpenses: 0,
      valuePropertyNetIncome: 0,
      valueInterestDividendsRoyalties: 0,
      valueUnemployment: 0,
      valueSocialSecurity: 0,
      valuePensionRetirement: 0,
      otherIncomes: 0,
      otherIncomesNames: "",
      valueTotalMonthlyIncome: 0 // 11

    }), _defineProperty(_incomeMeansTest, INTEREST_TYPES.DEBTOR_2, null), _defineProperty(_incomeMeansTest, "valueTotalMonthlyIncome", 0), _incomeMeansTest)
  };
  return base;
}

var createCaseContext = function createCaseContext() {
  return _objectSpread(_objectSpread({}, initialState()), {}, {
    debtor1: (0, createParty_1.default)({
      type: "debtor"
    }),
    id: (0, uuid_1.v4)()
  });
};

exports.default = createCaseContext;